import { Pipe, PipeTransform } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import firebase from 'firebase';

@Pipe({
  name: 'docRef',
})
export class DocRefPipe implements PipeTransform {
  constructor(private afs: AngularFirestore) {}

  transform(value: firebase.firestore.DocumentReference): Observable<any> {
    return this.afs.doc(value.path).valueChanges();
  }
}
